import React, { useState, useEffect, useContext } from 'react'
import HorizontalRowUI from './HorizontalRowUI.jsx'
import ProductLeftsideMenu from './ProductLeftsideMenu.jsx'
import CollapseMenu from './CollapseMenu.jsx'
import MenuComponent from './MenuComponent.jsx'
import { VscCollapseAll } from "react-icons/vsc";
import { AppContext } from "../contexts/AppContext.js";
import { getVersionsData, getWeeks_versionsForMonth, updateLatestVersion } from '../services/forecastService.js';
// import { getAllProducts, getVersionsData, getWeeks_versionsForMonth, updateLatestVersion } from '../services/forecastService.js';
// import { transformProductData } from '../utils/transformProductData.js';
import processWeeksRangesandVersions from '../utils/processWeeksRangesandVersions.js'
import reshapeProjectionResults from '../utils/reshapeProjectionResults.js'
export default function LeftComponent({ onLeafNodeClick, selectedItemName, allProduct, allProductCategories }) {
  // const [allProduct, setAllProduct] = useState([]);
  // const [allProductCategories, setAllProductCategories] = useState([]);
  // const [sopData, setSopData] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [weeksInSelectedMonth, setWeeksInSelectedMonth] = useState([]);
  const [versionsInSelectedWeek, setVersionsInSelectedWeek] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [selectedType] = useState('Primary');
  const [loading, setLoading] = useState({ month: false, week: false, version: false });
  const { activeTab, setActiveTab, toggle, allcollapse, setAllcollapse, setProjectedValues, setProjectedValuesLoaded, setEditingInputsValues, setVersionWeekNo, setProjectedMonthlyAggregationEdited, setAggregationsUnionArr } = useContext(AppContext);

  useEffect(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    setSelectedDate(`${year}-${month}`);
  }, []);

  // for fetching the default month's weeks and versions when a product is selected
  useEffect(() => {
    (async () => {
      if (!selectedItemName) return;
      const now = new Date();
      const yearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
      console.log("yearMonth", yearMonth);
      if (!yearMonth || yearMonth === undefined) return;

      setSelectedDate(yearMonth);
      setWeeksInSelectedMonth([])
      setLoading(s => ({ ...s, week: true }))
      const res = await getWeeks_versionsForMonth(selectedItemName, yearMonth);
      const processedWeeks = processWeeksRangesandVersions(res.weeks)
      console.log("processedWeeks", processedWeeks)
      setWeeksInSelectedMonth(processedWeeks)
      setLoading(s => ({ ...s, week: false }))

    })()

  }, [selectedItemName])

  const onMonthsChange = async (e) => {
    setSelectedDate(e.target.value)
    setWeeksInSelectedMonth([])
    console.log("selected date", e.target.value)
    setLoading(s => ({ ...s, week: true }))
    const res = await getWeeks_versionsForMonth(selectedItemName, e.target.value)
    console.log("res:", res)
    const processedWeeks = processWeeksRangesandVersions(res.weeks)
    console.log("processedWeeks", processedWeeks)
    setAggregationsUnionArr([]);
    setWeeksInSelectedMonth(processedWeeks)
    setLoading(s => ({ ...s, week: false }))
  }

  const handleWeekSelection = async (e) => {
    console.log("week selected", e.target.value)
    setVersionsInSelectedWeek([])
    setLoading(s => ({ ...s, version: true }))
    setSelectedWeek(e.target.value)
    const week_no = Number(e.target.value);
    console.log("weeksInSelectedMonth", weeksInSelectedMonth)
    weeksInSelectedMonth.forEach((week) => {
      if (week.week_no === week_no) {
        console.log("versionsInSelectedWeek", week)
        setVersionsInSelectedWeek(week.versions)
      }
    })
    setLoading(s => ({ ...s, version: false }))
  }

  const handleVersionSelection = async (e) => {
    console.log("version selected", e.target.value)
    const versionNumber = Number(e.target.value);
    // let is_latest = false;
    // versionsInSelectedWeek.forEach((version) => {

    //   if (version.version === versionNumber) {
    //     console.log("selected version is latest?", version, version.is_latest)
    //     is_latest = version.is_latest;
    //   }
    // })
    setSelectedVersion(versionNumber)
  }

  const handleFetchVersionData = async (e) => {
    setProjectedValuesLoaded(false)
    console.log("fetch version data for: ", selectedItemName, typeof selectedWeek, typeof selectedVersion)
    const res = await getVersionsData(selectedItemName, selectedWeek, selectedVersion)
    console.log("fetched version data: ", res)
    setVersionWeekNo(res.week_no)
    const fetchedVersionData = reshapeProjectionResults(res?.values?.results)
    console.log("reshape reshapeProjectionResults:", fetchedVersionData)

    if (res.aggregations_union_arr) {
      setAggregationsUnionArr(Array.isArray(res.aggregations_union_arr) ? res.aggregations_union_arr : [])
    }

    setProjectedMonthlyAggregationEdited(res?.monthly_aggregation_for_projection)

    const cloned = structuredClone(fetchedVersionData)
    console.log("cloned", cloned)


    setEditingInputsValues(cloned?.input)
    setProjectedValues(cloned)
    setProjectedValuesLoaded(true)
  }

  const handleSetVersionLatest = async () => {
    console.log("which version is selected right now: ", selectedWeek, selectedVersion, selectedItemName);
    if (selectedWeek == null || selectedVersion == null || selectedItemName == null) return;
    const res = await updateLatestVersion(selectedItemName, selectedWeek, selectedVersion);
    console.log("response from make version as latest api:", res)
  }

  const tabsData = [
    { id: 0, label: "Forecast" },
    { id: 1, label: "Consensus" },
    { id: 2, label: "Fcst Accuracy" },
  ]

  return (
    <div data-testid="left-component" style={{ display: toggle ? 'block' : 'none', padding: '8px' }}>
      <HorizontalRowUI>
        <ProductLeftsideMenu heightValue='200px' classProperty='scrolling'>
          <div className='datepicker_ui__button'>
            {tabsData.map((tab) => (
              <button
                key={tab.id}
                data-testid={`sidebar-tab-${tab.label.toLowerCase()}`}
                className={`button-primary ${activeTab === tab.id ? "tab active" : "tab"}`}
                onClick={() => { setActiveTab(tab.id); onLeafNodeClick(null); }}
                style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontWeight: 600, fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}
              >
                {tab.label}
              </button>
            ))}

          </div>
          <div className='period_selection mb-1'>
            <span className='mr-2 w-14' style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: '0.72rem', fontWeight: 600, color: '#52525B', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Period</span>
            <select data-testid="period-select" className='button-primary period_selection__select'>
              <option>Weekly</option>
              <option>Monthly</option>
            </select>
          </div>
          <div className='datepicker_ui'>
            <div className='from_datepicker'>
              <span className='mr-2 w-14' style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: '0.72rem', fontWeight: 600, color: '#52525B', textTransform: 'uppercase', letterSpacing: '0.05em' }}>From</span>
              <input type='month' className='button-primary from_datepicker__input'
                data-testid="month-picker"
                value={selectedDate}
                onChange={onMonthsChange}
                disabled={selectedItemName == null}
              />
            </div>

          </div>
          {activeTab === 1 || activeTab === 2 ? (
            <>
              <div className='flex justify-center'>
                <button data-testid="fetch-button" className={`${selectedWeek == null || selectedType == null || selectedItemName == null ? "cursor-not-allowed opacity-50" : ""} text-[0.75rem] font-semibold uppercase tracking-wider p-1 px-4 text-white mt-2`} style={{ background: selectedWeek == null || selectedType == null || selectedItemName == null ? '#A1A1AA' : '#002FA7', border: 'none', fontFamily: "'IBM Plex Sans', sans-serif" }} disabled={selectedWeek == null || selectedType == null || selectedItemName == null}>Fetch</button>
              </div>
            </>
          ) : (
            <>
              <div className='period_selection mb-1'>
                <span className='mr-2 w-14' style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: '0.72rem', fontWeight: 600, color: '#52525B', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Weeks</span>
                <select data-testid="week-select" className='button-primary period_selection__select' disabled={selectedItemName == null} onChange={handleWeekSelection}>
                  <option value=''>-- select week --</option>
                  {weeksInSelectedMonth && weeksInSelectedMonth?.map((week, idx) => (
                    <option value={week.week_no} key={idx + "_" + week.week_no}>W{week.week_no} : {week.start.split("-")[0]}-{week.end.split("-")[0]}</option>
                  ))}
                  {(weeksInSelectedMonth.length === 0 || loading.week) && <option>Loading...</option>}
                </select>
              </div>
              <div className='period_selection mb-1'>
                <span className='mr-2 w-14' style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: '0.72rem', fontWeight: 600, color: '#52525B', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Version</span>
                <select data-testid="version-select" className='button-primary period_selection__select' disabled={selectedItemName == null} onChange={handleVersionSelection}>
                  <option value=''>-- select version --</option>
                  {versionsInSelectedWeek?.map((version, idx) => (
                    <option value={version.version} key={idx + "_" + version.version}>V{version.version}{version.is_latest ? " [Latest]" : ""}</option>
                  ))}
                  {(versionsInSelectedWeek.length === 0 || loading.version) && <option>Loading...</option>}
                </select>
              </div>
              {<div>
                <button
                  data-testid="make-latest-version-button"
                  className={`${selectedWeek == null ||
                    selectedVersion == null ||
                    selectedItemName == null
                    ? "cursor-not-allowed opacity-50"
                    : ""
                    } text-[0.72rem] font-semibold uppercase tracking-wider p-1 px-3 text-white mt-2`}
                  style={{ background: (selectedWeek == null || selectedVersion == null || selectedItemName == null) ? '#A1A1AA' : '#002FA7', border: 'none', fontFamily: "'IBM Plex Sans', sans-serif" }}
                  disabled={
                    selectedWeek == null ||
                    selectedVersion == null ||
                    selectedItemName == null
                  }
                  onClick={handleSetVersionLatest}
                >
                  Make latest version for W-{selectedWeek}
                </button>
              </div>}
              <div className='flex justify-center'>
                <button data-testid="fetch-version-button" className={`${selectedWeek == null || selectedVersion == null || selectedItemName == null ? "cursor-not-allowed opacity-50" : ""} text-[0.75rem] font-semibold uppercase tracking-wider p-1 px-4 text-white mt-2`} style={{ background: (selectedWeek == null || selectedVersion == null || selectedItemName == null) ? '#A1A1AA' : '#002FA7', border: 'none', fontFamily: "'IBM Plex Sans', sans-serif" }} onClick={handleFetchVersionData} disabled={selectedWeek == null || selectedVersion == null || selectedItemName == null}>Fetch</button>
              </div>
            </>
          )}
        </ProductLeftsideMenu>
      </HorizontalRowUI>
      {/* product list start */}
      <HorizontalRowUI>
        <ProductLeftsideMenu heightValue='155px' classProperty='scrolling'>
          <CollapseMenu title="All Products" activeTab={activeTab}>
            <>
              <div className='flex justify-end w-full _collapse_all'>
                <VscCollapseAll title='Collapse all' onClick={() => setAllcollapse(!allcollapse)} />
              </div>
              {activeTab === 1 || activeTab === 2 ? (
                <MenuComponent AllProduct={allProductCategories} FullProductTree={allProduct} allcollapse={allcollapse} onLeafNodeClick={onLeafNodeClick} />
              ) : (
                <MenuComponent AllProduct={allProduct} allcollapse={allcollapse} onLeafNodeClick={onLeafNodeClick} />
              )}
            </>
          </CollapseMenu>
        </ProductLeftsideMenu>
      </HorizontalRowUI>
      {/* product list end */}
      {/* <HorizontalRowUI>
        <ProductLeftsideMenu classProperty='scrolling' heightValue='150px'>
          <CollapseMenu title="National">
            <MenuComponent AllProduct={MultiRegion} />
          </CollapseMenu>
          
        </ProductLeftsideMenu>
      </HorizontalRowUI> */}
    </div>
  )
}
